import { useEffect } from "react";

import "react-datepicker/dist/react-datepicker.css";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { HStack, Text, VStack } from "@chakra-ui/react";
import FiltersGrid from "../components/filters_grid";
import OrderTable from "../components/orders_page/order_table";
import useWindowDimensions from "../components/windowDimensions";
import LoaderIndicator from "../components/loader_indicator";

const OrdersPage = observer(() => {
  const { pageStore } = useStores();
  const { width } = useWindowDimensions();

  useEffect(() => {
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllPartners();
    pageStore.getAllAccountNumbers();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);
  
  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
         boxSizing="border-box"
      >
      <FiltersGrid
          page="orders"
          renderButtons={(buttons) => buttons}
        />
        <OrderTable data={pageStore.data_debitors} renderButtons={(buttons) => buttons} />
      </HStack>
    </VStack>
  );
});

export default OrdersPage;
